/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import ACToggleSwitch from './ACToggleSwitch';
import GenericButton from '../../common/GenericButton';
import {
    AC_APPLY_TITLE,
    AC_FUNCTIONS_TITLE,
    AC_APPLY_OPTIONS,
    AC_COUNT_OPTIONS,
    AC_COUNT_TITLE,
  } from '../AutocodeConstants';
import { funcsEnable } from '../AutocodeFunctions';

const ACFunctionBoxPanel = (props) => {
  const { selectedNodesCount, functionsOptionLIst, applyFunc, infoBoxRef,
    selectedFuncObj, selectedFuncCount, isSelected, trackActions } = props;
  const [rangeItem, setRangeItem] =  useState({ lower: 1, 
    upper: isSelected ? selectedFuncObj.rangeItem.upper : selectedNodesCount().length });
  const [exactCount, setExactCount] = useState({ lower: 1, upper: 1 });
  const inputStyles = {
    background: '#F8FBFF',
    border: '1px solid #94A2B7',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '39px',
    display: 'inline',
  };
  const [selectedFunc, setSelectedFunc] = useState(selectedFuncObj);
  const [applyTo, setApplyTo] = useState();
  const [funcDisabled, setFuncDisable] = useState(false);
  const [countDisabled, setCountDisable] = useState(false);
  const [applyToEnable, setApplyToEnable] = useState(!isSelected);
  const [selectedCountCoding, setSelectedCountCoding] = useState(null);

  const handleSwitch = (title, i, value, event) => {
    switch (title){
      case (AC_FUNCTIONS_TITLE):
        setSelectedFunc({ name: value, index:i, funcSele: true });
        setCountDisable(true);
        setApplyToEnable(false);
        break;        
      case (AC_APPLY_TITLE):    
        setApplyTo(i);
        setCountDisable(true);
        break;
      case (AC_COUNT_TITLE): 
        setFuncDisable(true);  
        setSelectedFunc({ name: value, index:i, funcSele: false });
        setSelectedCountCoding(i);
        setApplyToEnable(true);
        trackActions(title, i)
        break;
      default:
          break;
    }
    event.stopPropagation()
  };
  
  const handleClick = () => {
    if(selectedCountCoding === 1){
      applyFunc(selectedFunc.name, applyTo, rangeItem, isSelected);
    } else {
      applyFunc(selectedFunc.name, applyTo, exactCount, isSelected);
    }
  };

  const keyHandler = e => {
    switch (_.lowerCase(e.key)) {
      default:
        break;
      case 'enter': {
        if(selectedFunc.name)
          handleClick();
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case 'escape': {
        infoBoxRef.current.targetRef.current.click();
        break;
      }
    }
    e.preventDefault();
  };

  const resetSelection = (title) => {
    switch (title){
      case (AC_FUNCTIONS_TITLE):
          setSelectedFunc({});          
          setApplyTo();
          setCountDisable(false);
          setApplyToEnable(true);
          break;
      case (AC_COUNT_TITLE):
          setSelectedFunc({});          
          setApplyTo();
          setFuncDisable(false);
          setApplyToEnable(true);
          break;
      default:
        break;
    }
  };

  const child = [<input
        style={inputStyles}
        type="number"
        value={exactCount.lower}
        min="1"
        max={selectedNodesCount().length}
        onChange={(e) => setExactCount({ lower: e.target.value, upper: e.target.value })}
    />,
    <span>
          <input
            style={inputStyles}
            type="number"
            value={rangeItem.lower}
            min="1"
            max={selectedNodesCount().length}
            onChange={(e) => setRangeItem({ lower: e.target.value, upper: rangeItem.upper })}
          /> and max
          <input
            style={inputStyles}
            type="number"
            value={rangeItem.upper}
            min="1"
            max={selectedNodesCount().length}
            onChange={(e) => setRangeItem({ lower: rangeItem.lower, upper: e.target.value })}
          />
        </span>];
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div onKeyDown={e => keyHandler(e)} tabIndex="0" className="functionBox-panel">
      {((selectedNodesCount().length > 0 && funcsEnable(selectedNodesCount())) ||
        selectedFuncCount().count > 0 && funcsEnable(selectedFuncCount().node)) && (
      <React.Fragment>
        <ACToggleSwitch
          title={AC_FUNCTIONS_TITLE}
          resetSelection={resetSelection}
          optionList={functionsOptionLIst}
          handleSwitch={handleSwitch}
          checkedValue={!funcDisabled && selectedFunc.funcSele ? selectedFunc.index : null}
          isDisabled={funcDisabled}
        />
        <ACToggleSwitch
          title={AC_APPLY_TITLE}
          handleSwitch={handleSwitch}
          optionList={AC_APPLY_OPTIONS}
          checkedValue={applyTo}
          isDisabled={applyToEnable}
        />
      </React.Fragment>)}
      <ACToggleSwitch
       title={AC_COUNT_TITLE}
       handleSwitch={handleSwitch}
       child={child}
       optionList={AC_COUNT_OPTIONS}
       resetSelection={resetSelection}
       checkedValue={!countDisabled && !selectedFunc.funcSele ? selectedFunc.index : null}
       isDisabled={countDisabled}
     />
     <GenericButton
       name="Apply"
       btnStyle={selectedFunc.name === undefined ? 'disable-btn' : 'apply-func-btn'}
       onBtnClick={() => {handleClick()}}
       onKeyDown={e => keyHandler(e)}
     />
    </div>
  );
};

ACFunctionBoxPanel.propTypes = {
  applyFunc: PropTypes.func,
  functionsOptionLIst: PropTypes.bool,
  selectedNodesCount: PropTypes.func,
  selectedFuncCount: PropTypes.func,
  infoBoxRef: PropTypes.shape({
    current: PropTypes.shape({
      targetRef: PropTypes.shape({
        current: PropTypes.shape({
          click: PropTypes.func,
        }),
      }),
    }),
  }),
  isSelected: PropTypes.bool,
  selectedFuncObj: PropTypes.shape({
    rangeItem: PropTypes.shape({
      lower: PropTypes.number,
      upper: PropTypes.number,
    }),
  }),
  trackActions: PropTypes.func,
};

export default ACFunctionBoxPanel;
